'use strict';

require('slick-carousel/slick/slick.js');
require('slick-carousel/slick/slick.css');

var moduleName = 'slick-carousel';

module.exports = function () {
	$('body').each(function () {
		if ($.data(this, moduleName + '-init')) return;
		$.data(this, moduleName + '-init', true);



		$('[js-small-slider]').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			infinite: true,
			autoplaySpeed: 4000,
			speed: 600,
			prevArrow: '<button type="button" class="small-slider__btn-prev"></button>',
			nextArrow: '<button type="button" class="small-slider__btn-next"></button>'
		});



		$('[js-horizontal-slider]').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			infinite: true,
			fade: true,
			cssEase: 'linear',
			autoplaySpeed: 4000,
			speed: 600,
			arrows: false
		});



	});
};









/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/slickCarouselInit.js
 **/